<template>
	<main class="container mx-auto shadow bg-white">
		<section class="relative bg-cover bg-left pb-64 sm:pb-72 md:pb-80" :style="`background-image: url('${require('@/assets/image/Referral-Header.jpg')}')`">
			<div class="w-full text-center text-white px-2 py-4 leading-tight sm:py-16" style="background: linear-gradient(#1C1C1C, #1C1C1C99 85%, transparent);">
				<h1 class="text-2xl font-bold leading-tight tracking-wide sm:text-4xl lg:text-5xl xl:text-6xl">Your Friend is Giving You <span class="inline-block border-dish-red border-b-4 lg:border-b-6">$30 OFF</span></h1>
				<p class="mt-2 leading-none italic text-xl sm:mt-3 sm:text-3xl lg:mt-4 lg:text-4xl xl:text-5xl">Any of our satellite antenna bundles!</p>
			</div>
		</section>

		<section class="bg-dish-red py-5 px-2 sm:px-4 sm:py-6 md:py-8">
			<div v-if="!isSuccessful">
				<h3 class="text-white text-center leading-7 text-xl font-medium tracking-wide sm:font-semibold sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">Enter your email for your unique offer code!</h3>

				<form class="mt-4 sm:flex sm:justify-center lg:mt-6 xl:mt-8" @submit.prevent="claim">
					<input v-model="email" class="w-full mx-auto rounded bg-white py-1 px-4 sm:flex-grow sm:mx-0 sm:max-w-lg sm:text-lg md:max-w-sm lg:py-2 lg:text-xl xl:max-w-lg xl:text-2xl" required placeholder="Email" type="email" autocomplete="email">
					<button class="mt-2 w-full bg-white text-dish-red rounded py-1 px-4 font-bold sm:mt-0 sm:ml-4 sm:w-auto sm:flex-shrink-0 sm:text-lg md:w-48 md:ml-8 lg:w-64 lg:text-xl xl:text-2xl" type="submit" :class="{ spin: isLoading }">Claim Your Offer</button>
				</form>
			</div>
			<div v-else>
				<h3 class="text-white text-center leading-7 text-xl font-medium tracking-wide sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">Congratulations on claiming your offer!</h3>
				<div class="pt-px pb-px bg-white max-w-xs mx-auto mt-3 sm:max-w-md sm:mt-4 md:max-w-lg md:mt-6 lg:max-w-2xl xl:max-w-4xl xl:mt-8" />
				<p class="text-center text-white font-medium text-xl tracking-wide mt-3 sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">Use code: <span class="font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl"> {{ couponCode }}</span> <br> for <span class="font-bold">$30 OFF</span> any satellite antenna bundle.</p>
			</div>

			<p v-if="isInvalid" class="text-center text-white pt-2 font-medium sm:text-2xl md:font-semibold md:pt-4 lg:text-3xl">* We had an issue claiming your code. Try again later. *</p>
		</section>

		<AntennaBundles class="pt-8 pb-6 sm:pt-16 sm:pb-12" />

		<GetOurGuide class="py-5" style="background: #ebebeb" />

		<VideoSteps class="py-8" />

		<PayAsYouGo />

		<section class="py-6 px-4 text-center sm:py-12 md:px-8">
			<h2 class="text-3xl font-semibold leading-none sm:text-4xl xl:text-5xl">Flexible HD TV Programming</h2>
			<p class="mt-2 text-xl leading-tight sm:text-2xl xl:text-3xl">Pay As You Go programming packages with no contracts or commitments!</p>

			<div class="mt-12 -mx-4 md:-mx-8 lg:mx-0">
				<ChannelBoxes />
			</div>
		</section>

		<section class="px-6 py-8 text-center sm:pt-8 sm:pb-16">
			<div class="shadow-xl border border-gray-100 relative py-3 px-4 max-w-xl mx-auto rounded-lg md:py-6 md:px-8 md:max-w-2xl lg:max-w-4xl">
				<div class="absolute top-0 left-0">
					<img class="-mt-2 -ml-2 w-1/2 sm:w-3/4 sm:-mt-3 sm:-ml-3 md:w-auto md:-mt-4 md:-ml-4" :src="require('@/assets/image/exclusive-offer.svg')">
				</div>
				<div class="flex flex-col w-full sm:flex-row md:mx-0">
					<div class="w-full bg-left bg-no-repeat bg-cover sm:w-1/2 sm:mx-2 md:mr-4 md:ml-0" :style="`background-image: url(${require('@/assets/image/Referral-Card.jpg')})`">
						<div class="w-full h-32 sm:h-64" />
					</div>
					<div class="mx-2 mt-4 sm:mt-0 sm:w-1/2 md:ml-4 md:mr-0">
						<p class="text-2xl leading-tight font-medium lg:text-4xl lg:leading-10">Act now and get: <span class="price block text-6xl text-dish-red font-bold leading-none lg:text-7xl">30 OFF</span> your antenna and receiver bundle!</p>

						<div class="h-px bg-gray-900 mt-3" />

						<form v-if="!isSuccessful" class="mt-3 space-y-3 sm:space-y-3 lg:space-y-4" @submit.prevent="claim">
							<p class="text-xl leading-tight sm:text-2xl">Enter your email for your unique code:</p>
							<input v-model="email" class="w-full border-gray-300 shadow-inner border rounded bg-white py-2 px-4 sm:py-1 lg:text-xl" required placeholder="Email" type="email" autocomplete="email">
							<button class="w-full bg-dish-red text-white rounded py-2 px-4 font-semibold sm:py-1 lg:text-xl lg:font-bold" type="submit" :class="{ submitting: isLoading }">Claim Your Offer</button>
						</form>
						<div v-else>
							<p class="text-center font-medium text-xl leading-tight tracking-wide mt-3 md:text-2xl lg:text-3xl">Use code: <span class="font-bold text-dish-red text-2xl md:text-3xl lg:text-4xl"> {{ couponCode }}</span> <br> for <span class="font-bold">$30 OFF</span> any satellite antenna bundle.</p>
						</div>

						<p v-if="isInvalid" class="max-w-xs mx-auto text-center text-dish-red mt-2 font-bold sm:text-lg md:mt-4">We had an issue claiming your code. Try again later.</p>
					</div>
				</div>
			</div>
		</section>

		<CallToActivate />
	</main>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'
	import { useRoute } from 'vue-router'

	import AntennaBundles from '@/sections/AntennaBundles.vue'
	import ChannelBoxes from '@/sections/ChannelBoxes.vue'
	import CallToActivate from '@/sections/dividers/CallToActivate.vue'
	import PayAsYouGo from '@/sections/dividers/PayAsYouGo.vue'
	import GetOurGuide from '@/sections/GetOurGuide.vue'
	import VideoSteps from '@/sections/VideoSteps.vue'

	import { useClaimCoupon, useReferralInformation } from '../composables/useBackend'

	export default defineComponent({
		components: {
			VideoSteps,
			AntennaBundles,
			GetOurGuide,
			PayAsYouGo,
			CallToActivate,
			ChannelBoxes,
		},

		async setup() {
			const { params } = useRoute()
			const id = Array.isArray(params.referralId) ? params.referralId[0] : params.referralId
			await useReferralInformation(id)

			const { couponCode, email, isStatus, claim } = useClaimCoupon(id)

			return {
				email,
				couponCode,
				isLoading: isStatus('Loading'),
				isSuccessful: isStatus('Completed'),
				isInvalid: isStatus('Invalid'),
				claim,
			}
		},
	})
</script>

<style scoped>
	.price::before {
		content: '$';
		font-size: .5em;
		vertical-align: super;
	}

	input::placeholder {
		@apply text-gray-600;
	}

	.submitting {
		@apply text-transparent relative !important;
	}

	.submitting::after {
		@apply absolute border-4 border-dish-red w-6 h-6 rounded-full;
		content: ' ';
		left: calc(50% - .75rem);
		top: calc(50% - .75rem);
		border-color: #f0144644;
		border-top-color: #f01446;
		animation: spinning 1.5s ease-in-out 0s infinite;
	}

	@keyframes spinning {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(720deg);
		}
	}
</style>
